import { render, staticRenderFns } from "./assemblyReceipts.vue?vue&type=template&id=545fb6b0&scoped=true"
import script from "./assemblyReceipts.vue?vue&type=script&lang=js"
export * from "./assemblyReceipts.vue?vue&type=script&lang=js"
import style0 from "./assemblyReceipts.vue?vue&type=style&index=0&id=545fb6b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545fb6b0",
  null
  
)

export default component.exports